import styled, { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import img from '../../images/back-to-top.svg';
import { fixPropWarnings } from '../../utils/fixPropWarnings';

export const BackToTopWrapper = styled.div`
  text-align: center;
`;

interface ScrollUpButtonProps {
  isVisible: boolean;
}

export const ScrollUpButton = styled.a
  .attrs({ tabIndex: 0 })
  .withConfig(fixPropWarnings('isVisible'))<ScrollUpButtonProps>`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: fixed;
  padding: 0.75rem;
  transition: all 0.5s;
  background-color: ${themeGet('colors.white')};
  border-radius: 0.3rem 0 0 0.3rem;
  bottom: 25%;
  z-index: 500;
  /* Right -(size of button) to hide it completely off screen */
  right: -100px;
  width: 90px;
  box-shadow: 0 0 0.5rem 0.1rem rgba(0, 0, 0, 0.2);

  &:hover {
    background-color: ${themeGet('colors.greys.2')};
    p {
      color: ${themeGet('colors.white')};
    }
  }

  span {
    color: ${themeGet('colors.black')};
    clear: both;
    text-align: center;
    position: relative;
    padding: 0;
    margin-bottom: 0;
    transition: all 0.5s;
    font-size: 16px;
  }

  ${({ isVisible }) => isVisible
    && css`
      right: 0;
      transition: all 0.5s;
    `};
`;

export const BackgroundImage = styled.span`
  background-image: url(${img});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 40px;
  width: 40px;
  margin-bottom: 0.25rem;
`;
